import { apiClient, unwrap } from './client';

import type { User } from '@/types';

export interface LLMKeyConfig {
  api_key: string;
  provider?: string;
  base_url?: string;
  model?: string;
  vision_model?: string;
}

export interface LLMKeyInfo {
  provider: string;
  base_url?: string;
  model?: string;
  vision_model?: string;
  has_key: boolean;
  updated_at?: string;
}

export interface ProfileUpdatePayload {
  nickname?: string;
  avatar_url?: string;
}

export interface SecurityQuestionPayload {
  security_question: string;
  security_answer: string;
}

export interface ChangePasswordPayload {
  old_password: string;
  new_password: string;
}

export async function getLLMKeyInfo(): Promise<LLMKeyInfo> {
  const response = await apiClient.get('/users/me/llm-key');
  return unwrap(response);
}

export async function updateLLMKey(payload: LLMKeyConfig): Promise<LLMKeyInfo> {
  const response = await apiClient.put('/users/me/llm-key', payload);
  return unwrap(response);
}

export async function deleteLLMKey(): Promise<{ deleted: boolean }> {
  const response = await apiClient.delete('/users/me/llm-key');
  return unwrap(response);
}

export async function updateProfile(payload: ProfileUpdatePayload): Promise<User> {
  const response = await apiClient.put('/users/me/profile', payload);
  return unwrap(response);
}

export async function uploadAvatar(file: File): Promise<User> {
  const formData = new FormData();
  formData.append('file', file);
  const response = await apiClient.post('/users/me/avatar', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return unwrap(response);
}

export async function updateSecurityQuestion(payload: SecurityQuestionPayload): Promise<User> {
  const response = await apiClient.put('/users/me/security-question', payload);
  return unwrap(response);
}

export async function changePassword(payload: ChangePasswordPayload): Promise<{ ok: boolean }> {
  const response = await apiClient.put('/users/me/password', payload);
  return unwrap(response);
}
